module.exports = __webpack_public_path__ + "img/e4.fe1b63dc.svg";